import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/inspectionPoint',
    meta: { title: '巡查点位' },
    component: Layout,
    redirect: '/inspectionPoint/list',
    children: [
      {
        path: 'list',
        meta: { title: '巡查点位', activeMenu: '/inspectionPoint' },
        component: () => import('@/views/inspectionPoint/InspectionPoint.vue')
      },
      {
        path: 'detail',
        meta: { title: '巡查点位详情', activeMenu: '/inspectionPoint' },
        component: () => import('@/views/inspectionPoint/InspectionPointDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增巡查点位', activeMenu: '/inspectionPoint' },
        component: () => import('@/views/inspectionPoint/InspectionPointAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑巡查点位', activeMenu: '/inspectionPoint' },
        component: () => import('@/views/inspectionPoint/InspectionPointAdd.vue')
      }

    ]
  }

]
